export const DEFAULT = 'default';
export const DARK = 'dark';
export const DARK_BLACK_FRIDAY = 'darkBlackFriday';
export const ALL_THEMES = [DEFAULT, DARK, DARK_BLACK_FRIDAY];
